export default __webpack_public_path__ + "static/media/tribe_pool.4f3298c5.png";